(function () {
  'use strict';

  var toggle   = document.getElementById('azur-mobile-toggle');
  var drawer   = document.getElementById('azur-mobile-drawer');
  var closeBtn = document.getElementById('azur-mobile-close');
  var backdrop = document.getElementById('azur-mobile-backdrop');

  if (!toggle || !drawer) return;

  // ── Open / close ──────────────────────────────────────────────────

  function openMenu() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('azur-mobile-menu-open');
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('azur-mobile-menu-open');
    toggle.focus();
  }

  toggle.addEventListener('click', function () {
    drawer.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  if (closeBtn)  closeBtn.addEventListener('click', closeMenu);
  if (backdrop)  backdrop.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // ── Accordion ────────────────────────────────────────────────────

  drawer.querySelectorAll('.azur-mobile-accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panelId = btn.getAttribute('aria-controls');
      var panel   = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.setAttribute('aria-hidden', String(isOpen));
      panel.classList.toggle('is-open', !isOpen);
    });
  });
})();
